import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "context/LanguageContext";
import { useNotification } from "context/NotificationContext";
import {
  renderYesNoField,
  renderInputTextField,
  renderRangeField,
  convertYesNoFieldsToString,
  handleConfirmSave,
  validateFields,
  handleNavigateBack,
  renderSelectField
} from "components/formUtils";

const ObitoForm = () => {
  const { GetTranslation } = useLanguage();
  const notify = useNotification();
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    obito_intra_hospitalar: "",
    motivo_obito: "",
    momento_obito: "",
    obito_durante_seguimento: "",
    tempo_obito_apos_cirurgia: ""
  });

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (id) {
      fetch(`${process.env.REACT_APP_API_URL}/obito/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            const yesNoFields = [
              "obito_intra_hospitalar",
              "obito_durante_seguimento"
            ];
            const convertedData = convertYesNoFieldsToString(data.data, yesNoFields);
            setFormData(convertedData);
          } else {
            notify({
              type: "error",
              message: data.error || "Erro ao buscar os dados",
            });
          }
        })
        .catch(() => {
          notify({
            type: "error",
            message: "Erro ao buscar os dados",
          });
        });
    }
  }, [id, token, notify]);

  const apiUrl = id
    ? `${process.env.REACT_APP_API_URL}/obito/update/${id}`
    : `${process.env.REACT_APP_API_URL}/obito/add`;

  const handleSubmit = () => {
    const method = id ? "PUT" : "POST";
    fetch(apiUrl, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (response.ok) {
          notify({
            type: "success",
            message: id ? "Óbito atualizado com sucesso!" : "Óbito adicionado com sucesso!",
          });
        } else {
          response.json().then((data) => {
            notify({
              type: "error",
              message: `Erro: ${data.error}`,
            });
          });
        }
      })
      .catch(() => {
        notify({
          type: "error",
          message: "Erro ao enviar os dados",
        });
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const confirmSave = handleConfirmSave(formData, [], validateFields, GetTranslation, notify, handleSubmit);
  const handleBack = handleNavigateBack(navigate, id);

  return (
    <div className="card p-3">
      <ConfirmDialog />
      <h4>{id ? GetTranslation("Edit_Obito") : GetTranslation("Add_Obito")}</h4>
      <form className="row g-3">
        {/* Óbito Intra-hospitalar */}
        {renderYesNoField(
          formData,
          handleChange,
          "obito_intra_hospitalar",
          "Óbito intra-hospitalar",
          GetTranslation
        )}

        {/* Motivo do Óbito */}
        {formData.obito_intra_hospitalar === "1" &&
          renderInputTextField(
            formData,
            handleChange,
            "motivo_obito",
            "Motivo do óbito",
            GetTranslation
          )}

        {/* Momento do Óbito */}
        {renderSelectField(
          formData,
          handleChange,
          "momento_obito",
          "Momento do óbito",
          ["Intra-operatório", "UTI", "Enfermaria"],
          GetTranslation
        )}

        {/* Óbito Durante Seguimento */}
        {renderYesNoField(
          formData,
          handleChange,
          "obito_durante_seguimento",
          "Óbito durante seguimento",
          GetTranslation
        )}

        {/* Tempo do Óbito após Cirurgia */}
        {formData.obito_durante_seguimento === "1" &&
          renderRangeField(
            formData,
            setFormData,
            "tempo_obito_apos_cirurgia",
            "Tempo do óbito após cirurgia (dias)",
            0,
            2000,
            0,
            GetTranslation
          )}

        <div className="col-12 d-flex justify-content-between">
          <Button label={GetTranslation("Voltar")} className="btn btn-secondary" onClick={handleBack} />
          <Button label={id ? GetTranslation("Update") : GetTranslation("Create")} className="btn btn-primary" type="submit" onClick={confirmSave} />
        </div>
      </form>
    </div>
  );
};

export default ObitoForm;
